import { render } from "./CustomSet.vue?vue&type=template&id=772ac5ec&scoped=true&ts=true"
import script from "./CustomSet.vue?vue&type=script&lang=ts"
export * from "./CustomSet.vue?vue&type=script&lang=ts"

import "./CustomSet.vue?vue&type=style&index=0&id=772ac5ec&lang=less&scoped=true"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-772ac5ec"]])

export default __exports__